import authentication from './modules/authentication';
import localization from './modules/localization';
import menu from './modules/menu';


export default function(area) {
    return {
        authentication,
        localization,
        menu
    };
} 


// WEBPACK FOOTER //
// ./src/store/modules.js